// extracted by mini-css-extract-plugin
module.exports = {"MiniSideBar":"MiniSideBar_MiniSideBar__NO3wi","Second":"MiniSideBar_Second__1Wqlc","NavItems":"MiniSideBar_NavItems__2kLyG","ActiveItem":"MiniSideBar_ActiveItem__1Y_5Z"};